<div [formGroup]="form">
  <div class="tw-flex tw-gap-10">
    <div class="tw-inline-flex tw-items-center">
      <label
        class="tw-relative tw-flex tw-cursor-pointer tw-items-center tw-rounded-full tw-p-3"
        data-ripple-dark="true"
      >
        <input
          type="radio"
          [attr.id]="radioIdex"
          [attr.name]="name"
          [value]="value"
          (change)="handleRadioSelected($event)"
          [formControlName]="controlName"
          class="before:tw-content[''] tw-peer tw-relative tw-h-5 tw-w-5 tw-cursor-pointer tw-appearance-none {{
            props?.input
          }} tw-rounded-full tw-border tw-border-blue-gray-200 tw-transition-all before:tw-absolute before:tw-top-2/4 before:tw-left-2/4 before:tw-block before:tw-h-12 before:tw-w-12 before:-tw-translate-y-2/4 before:-tw-translate-x-2/4 before:tw-rounded-full before:tw-bg-blue-gray-500 before:tw-opacity-0 before:tw-transition-opacity hover:before:tw-opacity-10"
        />
        <div
          class="tw-pointer-events-none tw-absolute tw-top-2/4 tw-left-2/4 -tw-translate-y-2/4 -tw-translate-x-2/4 {{
            props?.container
          }} tw-opacity-0 tw-transition-opacity peer-checked:tw-opacity-100"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3.5 w-3.5"
            viewBox="0 0 16 16"
            fill="currentColor"
          >
            <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
          </svg>
        </div>
      </label>
      <label
        class="tw-mt-px tw-cursor-pointer tw-select-none tw-font-light tw-text-gray-700"
        for="{{ radioIdex }}"
      >
        {{ label }}
      </label>
    </div>
  </div>
  <div
    class="tw-ml-3 tw-text-sm tw-flex tw-items-center tw-gap-1 {{
      isError ? 'tw-text-red-500' : ''
    }}"
  >
    @if (isError) {
      <span class="material-icons tw-mr-1 tw-text-xl">error_outline</span>
    }
    {{ helperText }}
  </div>
</div>
